// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__cPvR+","textarea":"Textarea_textarea__EEtQm","error":"Textarea_error__d8H10"};